<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1 class="mb-3">لیست زبان آموزان در انتظار تعیین سطح</h1>
          <div class="my-2">
            <!-- Table Top Start -->
            <b-row>
              <!-- Search -->
              <b-col cols="12" md="12">
                <user-picker @getUser="setUserId"></user-picker>
              </b-col>
            </b-row>
          </div>
          <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="studentsList"
            responsive
            :fields="myTableColumns"
            primary-key="id"
            show-empty
            bordered
            striped
            empty-text="موردی موجود نیست!"
          >
            <template #cell(specify)="data">
              <div
                v-if="data.item.status == 1"
                class="d-flex align-items-center justify-content-center"
                style="cursor: pointer"
              >
                <b-link
                  :to="`/students/pending-to-specify-level/${data.item.studentLanguageId}`"
                >
                  <feather-icon
                    icon="ExternalLinkIcon"
                    class="text-primary"
                    size="20"
                  />
                </b-link>
              </div>
              <div v-else>-</div>
            </template>
            <template #cell(status)="data">
              {{ statusEnum[data.item.status] }}
            </template>
          </b-table>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end py-2"
          >
            <b-pagination
              v-model="pageNumber"
              :total-rows="totalCount"
              :per-page="count"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  style="transform: rotate(180deg)"
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
import { GetAllStudentLanguages } from "../../../libs/Api/StudentLanguage";
import UserPicker from "../../components/Users/UserPicker.vue";
import {
  BCard,
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BModal,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
export default {
  data() {
    return {
      statusEnum: {
        1: "در انتظار تعیین سطح",
        2: "تعیین سطح شده",
      },
      myTableColumns: [
        {
          key: "studentLanguageId",
          label: "شناسه درخواست تعیین سطح",
        },
        {
          key: "studentUserInfo.fullName",
          label: "نام زبان آموز",
        },
        {
          key: "languageInfo.persianTitle",
          label: "زبان انتخاب شده",
        },
        {
          key: "studentUserInfo.mobile",
          label: "شماره همراه زبان آموز",
        },
        {
          key: "status",
          label: "وضعیت تعیین سطح",
        },
        {
          key: "specify",
          label: "تعیین سطح زبان آموز",
        },
      ],
      totalCount: null,
      count: 20,
      pageNumber: 1,
      studentsList: null,
      studentUserId: null,
      isLoading: false,
    };
  },
  watch: {
    pageNumber: {
      handler(val) {
        this.getAllStudents();
      },
    },
  },
  mounted() {
    this.getAllStudents();
  },
  methods: {
    setUserId(userId) {
      this.studentUserId = userId;
      this.getAllStudents();
    },
    async getAllStudents() {
      // Status ENUM:
      //   {
      //     WaitingForPlacement = 1,
      //     Specified
      // }
      try {
        this.isLoading = true;
        let _this = this;
        let getAllStudentLanguages = new GetAllStudentLanguages(_this);
        let qParams = {
          count: _this.count,
          pageNumber: _this.pageNumber,
          status: 1,
        };
        if (this.studentUserId) {
          qParams["studentUserId"] = this.studentUserId;
        }
        getAllStudentLanguages.setRequestParam(qParams);
        await getAllStudentLanguages.fetch(
          function (response) {
            if (response.isSuccess) {
              _this.totalCount = response.data.studentsCount;
              _this.studentsList = response.data.studentLanguages;
            }
          },
          function (error) {
            console.error(error);
          }
        );
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    UserPicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BModal,
    BButton,
    BForm,
    BFormGroup,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
  },
};
</script>
